import { ColDef } from 'ag-grid-community';
import { advancedTextColumnFilterOptions } from 'src/components/molecules/AdvancedTextColumnFilter/AdvancedTextColumnFilter';
import { InventoryMasterDataRow } from 'src/hooks/inventory-master-data/table/useInventoryMasterDataRows';

export const defaultColDef: ColDef = {
    flex: 1,
    sortable: false,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
};

export const defaultColumns: ColDef<InventoryMasterDataRow>[] = [
    {
        field: 'name',
        headerName: 'Name',
        rowDrag: true,
        ...advancedTextColumnFilterOptions,
    },
    {
        field: 'description',
        headerName: 'Description',
        ...advancedTextColumnFilterOptions,
    },
    {
        field: 'typeName',
        headerName: 'Type',
        filter: 'agSetColumnFilter',
    },
];
